import { IUIStore, useUIStore } from "./Store.ts";
import Toast from "./Toast.tsx";
import { produce } from "immer";

export const Toasts = () => {
  const toasts = useUIStore((s) => s.toasts);

  return (
    <div className="toast-container position-fixed top-0 end-0 p-3">
      {toasts.map((toast) => (
        <Toast key={toast} toast={toast} />
      ))}
    </div>
  );
};

export const AddToast = (toast: unknown) => {
  useUIStore.setState(
    produce((s: IUIStore) => {
      if (typeof toast !== "string") {
        console.warn("Bad toast", toast);
        return;
      }
      if (!s.toasts.includes(toast)) {
        s.toasts.push(toast);
      }
    }),
  );
};
